import React from 'react';
import { connect } from 'react-redux';
import Base from './Base';

const PerformanceHsClubHeader = props => {
    const {
        clubName,
        upgradePopup,
    } = props;
    const { data } = upgradePopup;
    let title = 'Upgrade to Performance High School';
    if (clubName) {
        title = `Upgrade <span> ${clubName}</span> to <span>Performance High School</span>`;
    }

    const subText = (
        <React.Fragment>
            {data.checkoutbulletpoints.map((bulletpoint, i) => (
                <div key={`phs-bullet-${i}`}>{bulletpoint}</div>

            ))}
        </React.Fragment>
    );

    return (
        <Base
            title={title}
            subText={subText}
            {...props}
        />
    );
};

const mapStateToProps = ({ upgradePopup }) => {
    return { upgradePopup };
};

export default connect(mapStateToProps, null)(PerformanceHsClubHeader);
